import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AlertController, Platform, ToastController } from '@ionic/angular';
import { AuthService } from '@common/services/auth.service';
import { AlertModel } from '../models/alert.model';
import { PlatformDetails } from '../models/platform-details';

@Injectable({providedIn:'root'})
export class CommonService {


  public static requestTracker:string[] =[];

  public static loaderStatus = new Subject<boolean>();
  
  private _platform_details: PlatformDetails;

  kycStatusMessage: boolean = false;
  

  constructor(private platform: Platform, private alertCtrl: AlertController, private toastCtrl: ToastController) {
    this.initailizePlatformDetails();
  }

  public static showLoader()  {
    this.loaderStatus.next(true);
  };

  public static hideLoader()  {
      this.loaderStatus.next(false);
  };
  

  initailizePlatformDetails() {
    this._platform_details = {
      isDesktop: this.platform.is('desktop'),
      isMobile: this.platform.is('mobile'),
      isMobileBrowser: this.platform.is('mobileweb'),
      isMobileApp: this.platform.is('cordova'),
      isAndroidApp: this.platform.is('android'),
      isIosApp: this.platform.is('ios'),
      isIPad: this.platform.is('ipad')
    }
  }

  getPlatformDetails() {
    return this._platform_details;
  }

  getSource(){
    return this._platform_details.isDesktop || this._platform_details.isMobileBrowser ? 'W' : 'M';
  }

  getTodayDate(){
    let todayDate = new Date();
    let dd = String(todayDate.getDate());
    let mm = todayDate.getMonth() + 1;
    let yyyy = todayDate.getFullYear();
    return mm + '/' + dd + '/' + yyyy;
  }

  getInvestorPan(){
    const sessionInfo = AuthService.getSessionInfo();
    if(sessionInfo){
      return sessionInfo.pan;
    }
  }

  formatINR(num) {
    num=parseFloat(num)
    num=Math.round((num + Number.EPSILON) * 100) / 100
    let n1;
    let n2;
    num = num + '' || '';
    n1 = num.split('.');
    if(n1[1] == undefined || n1[1].length == 0 ){
      n2 = "00";
    }
    else if(n1[1].length == 1){
      n2 = n1[1] + '0';
    }
    else {
      n2 = n1[1] || null;
    }
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
  }

  customDate = (value) => {
    const month = new Array();
    const parseDate = new Date(value);
    let suffix = 'th';
    const day = parseDate.getDate().toString();
    month[0] = 'January';
    month[1] = 'February';
    month[2] = 'March';
    month[3] = 'April';
    month[4] = 'May';
    month[5] = 'June';
    month[6] = 'July';
    month[7] = 'August';
    month[8] = 'September';
    month[9] = 'October';
    month[10] = 'November';
    month[11] = 'December';

    if (day === '1' || day === '21' || day === '31') {
            suffix = 'st';
        } else if (day === '2' || day === '22') {
            suffix = 'nd';
        } else if (day === '3' || day === '23') {
           suffix = 'rd';
        }
    return day + suffix + ' ' + month[parseDate.getMonth()] + ' ' + parseDate.getFullYear();
  }

 
  async showAlert(_alertObj: AlertModel) {
    const alert = await this.alertCtrl.create({
      header: _alertObj.header,
      subHeader: _alertObj.subHeader,
      message: _alertObj.message,
      backdropDismiss: false,
      cssClass: 'alert-css',
      buttons: [{
        text: _alertObj.leftBtnTxt,
        role: _alertObj.leftBtnRole,
        handler: _alertObj.leftBtnHandler
      }, {
        text: _alertObj.rightBtnTxt,
        role: _alertObj.rightBtnRole,
        handler: _alertObj.rightBtnHandler
      }]
    });
    await alert.present();
  }

  async showToast(msg: string, duration:number, cssClass:string) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: duration,
      position: "top",
      cssClass: cssClass
    })
    await toast.present();
  }

  setKycStatus(kycStatusMessage) {
    this.kycStatusMessage = kycStatusMessage;
  }

  getKycStatus() {
    return this.kycStatusMessage;
  }
  
}
